module.exports = __webpack_public_path__ + "static/media/neuwt.7b8f90ff.png";